module.exports = __webpack_public_path__ + "static/img/92-1.6447afa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/92-1.jpg
// module id = WYGy
// module chunks = 0